import { Badge } from "@volca/ui/components/ui/badge";
import { cn } from "@volca/ui/lib/utils";
import { dayjs } from "@/core/utils/date";
import { ReferralSource } from "@/referral-sources/referral-source";

export const REFERRAL_SOURCE_STATUSES = {
  notStarted: "Not started",
  active: "Active",
  ended: "Ended",
} as const;

export const calcReferralSourceStatus = (
  referralSource: ReferralSource,
): (typeof REFERRAL_SOURCE_STATUSES)[keyof typeof REFERRAL_SOURCE_STATUSES] => {
  const startDate = dayjs(referralSource.start_date);
  const endDateStr = referralSource.end_date;
  const endDate = endDateStr && dayjs(endDateStr);
  const today = dayjs().startOf("day");

  if (startDate > today) {
    return REFERRAL_SOURCE_STATUSES.notStarted;
  } else if (endDate && endDate < today) {
    return REFERRAL_SOURCE_STATUSES.ended;
  } else {
    return REFERRAL_SOURCE_STATUSES.active;
  }
};

export const ReferralSourceStatusBadge = ({
  status,
  className = "",
}: {
  status: (typeof REFERRAL_SOURCE_STATUSES)[keyof typeof REFERRAL_SOURCE_STATUSES];
  className?: string;
}) => (
  <Badge
    variant="secondary"
    color={status === REFERRAL_SOURCE_STATUSES.active ? "success" : "neutral"}
    className={cn("h-auto min-h-6 px-2.5 text-sm text-nowrap", className)}
  >
    {status}
  </Badge>
);
